"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _immutable = _interopRequireDefault(require("immutable"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _UIList = _interopRequireDefault(require("UIComponents/list/UIList"));

var MAX_LIST_ITEMS = 4;

function getTotalPackCounts(packCounts) {
  return packCounts.reduce(function (total, packCount) {
    return total + packCount.get('count');
  }, 0);
}

var PackCounts =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(PackCounts, _PureComponent);

  function PackCounts() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, PackCounts);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(PackCounts)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.renderPackCount = function (packCount, index, abbreviateList) {
      if (abbreviateList && index >= MAX_LIST_ITEMS) {
        return null;
      }

      var subType = packCount.get('subType');
      return _react.default.createElement("span", {
        key: subType
      }, _react.default.createElement(_FormattedMessage.default, {
        message: "marketplacelib.packCounts.subTypes." + subType,
        options: {
          count: packCount.get('count')
        }
      }));
    };

    _this.renderOverflowText = function (packCounts, abbreviateList) {
      if (abbreviateList && packCounts.size > MAX_LIST_ITEMS) {
        return _react.default.createElement("span", {
          className: "pack-counts-overflow-text"
        }, _react.default.createElement(_FormattedMessage.default, {
          message: "marketplacelib.packCounts.overflowText",
          options: {
            numberOfMoreTemplates: packCounts.size - MAX_LIST_ITEMS
          }
        }));
      }

      return null;
    };

    return _this;
  }

  (0, _createClass2.default)(PackCounts, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          abbreviateList = _this$props.abbreviateList,
          packCounts = _this$props.packCounts,
          showHeader = _this$props.showHeader;
      return _react.default.createElement("div", null, showHeader && _react.default.createElement("h5", null, _react.default.createElement(_FormattedMessage.default, {
        message: "marketplacelib.packCounts.title",
        options: {
          count: getTotalPackCounts(packCounts)
        }
      })), _react.default.createElement(_UIList.default, {
        styled: true,
        className: "p-left-5"
      }, packCounts.map(function (packCount, index) {
        return _this2.renderPackCount(packCount, index, abbreviateList);
      })), this.renderOverflowText(packCounts, abbreviateList));
    }
  }]);
  return PackCounts;
}(_react.PureComponent);

exports.default = PackCounts;
PackCounts.propTypes = {
  abbreviateList: _react.PropTypes.bool,
  packCounts: _react.PropTypes.instanceOf(_immutable.default.List).isRequired,
  showHeader: _react.PropTypes.bool
};
PackCounts.defaultProps = {
  abbreviateList: false,
  showHeader: true
};
module.exports = exports.default;